import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import { validateCustomerSmsSubscriberCondition } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type CustomerSmsSubscriberState = void;

export const CUSTOMER_SMS_SUBSCRIBER = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<CustomerSmsSubscriberState>
  >,
): ConditionType<
  CustomerSmsSubscriberState,
  Condition.CustomerSmsSubscriber
> => ({
  name: CONDITION_NAMES[Condition.CUSTOMER_SMS_SUBSCRIBER],
  description() {
    return t("Customer is an SMS subscriber");
  },
  Details(props: ConditionTypeDetailsProps<CustomerSmsSubscriberState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.CUSTOMER_SMS_SUBSCRIBER };
  },
  valid() {
    return validateCustomerSmsSubscriberCondition({}).valid;
  },
});
